/**
 * Reads width and height from an image File using the browser Image API.
 * @param {File} file
 * @returns {Promise<{ width: number; height: number }>}
 */
export function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    if (!file || typeof file.type !== 'string' || !file.type.startsWith('image/')) {
      reject(new Error('Invalid image file.'));
      return;
    }

    const reader = new FileReader();

    reader.onerror = () => {
      reject(new Error('Could not read the image file.'));
    };

    reader.onload = (e) => {
      const dataUrl = e.target?.result;
      if (typeof dataUrl !== 'string') {
        reject(new Error('Could not read the image file.'));
        return;
      }

      const img = new Image();

      img.onload = () => {
        const width = img.naturalWidth || img.width;
        const height = img.naturalHeight || img.height;
        if (!width || !height) {
          reject(new Error('Could not determine image dimensions.'));
          return;
        }
        resolve({ width, height });
      };

      img.onerror = () => {
        reject(new Error('The file is not a valid image or is corrupted.'));
      };

      img.src = dataUrl;
    };

    reader.readAsDataURL(file);
  });
}
